/**
 * SMSContent.js
 * 
 * Created on Oct 21, 2013, 11:44:11 AM
 *
 * @author Olivier van der Pool for Ranj
 **/

import { isNull, isUndefined } from "../../util/TypeUtil";
import Content from "./Content";

export default class SMSContent extends Content {
    constructor(languagePack, contentID, sender, text, dateTimeOffset, label) {
        isUndefined(contentID) ? contentID = null : null;
        isUndefined(sender) ? sender = null : null;
        isUndefined(text) ? text = null : null;
        isUndefined(dateTimeOffset) ? dateTimeOffset = 0 : null;
        isUndefined(label) ? label = null : null;

        super(SMSContent.NAME, SMSContent.TYPE, label, languagePack, contentID);

        this.dateTimeOffset = dateTimeOffset;
        this.opened = false;
        this.sender = sender;
        this.text = text;

    }

    setText(value) {
        if (this.text !== value) {
            this.setLanguagePackText(SMSContent.TEXT_LABEL, value);
        }
    }

    getText() {
        return this.getLanguagePackText(SMSContent.TEXT_LABEL);
    }

    setSender(value) {
        if (this.sender !== value) {
            this.setLanguagePackText(SMSContent.SENDER_LABEL, value);
        }
    }

    getSender() {
        return this.getLanguagePackText(SMSContent.SENDER_LABEL);
    }

    setDate(value) {
        if (this._date !== value) {
            this._date = value;
        }
    }

    getDate() {
        return this._date;
    }

    getDateTimeOffset() {
        return this.dateTimeOffset;
    }

    setDateTimeOffset(value) {
        this.dateTimeOffset = value;
    }

    setDateWithOffset(currentDate) {
        if (isUndefined(currentDate)) {
            currentDate = new Date();
        }
        this._date = new Date();
        this._date.time = currentDate.time + this.dateTimeOffset;
    }

    setOpened(value) {
        this.opened = value;
    }

    getOpened() {
        return this.opened;
    }

    setPropertiesFromObject(object) {
        if (object.date) {
            this._date = new Date(object.date);
            delete object.date;
        }
        super.setPropertiesFromObject(object);
    }

    exportText(csv) {
        console.warn("[SMSContent]", "the method exportText is not yet implemented!");
        //this.exportText(csv);
        //csv.addRecordSet([this.getLanguagePackLabel(SENDER_LABEL), this.getLanugagePackText(SENDER_LABEL), "sms sender"]);
        //csv.addRecordSet([this.getLanguagePackLabel(TEXT_LABEL), this.getLanugagePackText(TEXT_LABEL), "sms text"]);
    }

    convertToObject() {
        const object = this.getObject(["opened", "dateTimeOffset"]);
        if (!isNull(this._date)) {
            object.date = this._date.valueOf();
        }
        return object;
    }
}

SMSContent.NAME = "SMS";
SMSContent.TYPE = "engSMSContent";
SMSContent.SENDER_LABEL = "sender";
SMSContent.TEXT_LABEL = "text";

